<template>
	<section class="container-fluid">
		<div class="offset-xl-3 col-xl-6 offset-md-2 col-md-8">
			<div class="row">
				<div class="col-12">
					<h1>Tasks</h1>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<div class="row options-bar">
						<button class="add-item" @click="addOpen = true">Add Task <i class="ss-plus ss-glyphish-filled"></i></button>
						<Search v-on:foundItems="filteredList" defaultText="Search Tasks" :items="tasks" />
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<List :tasks="foundTasks.length ? foundTasks : tasks" @edit="editTask" @delete="deleteTask"/>
				</div>
			</div>
			<Add v-if="addOpen" @close="addOpen = false"/>
			<Edit v-if="editOpen" @close="editOpen = false" :task="selected"/>
			<Delete v-if="deleteOpen" @close="deleteOpen = false" :task="selected"/>
		</div>
	</section>
</template>

<script>
import { mapState } from 'vuex'
import Search from '../Form/Search'
import List from '../Tasks/List.vue'
import Add from '../Tasks/Add.vue'
import Edit from '../Tasks/Edit.vue'
import Delete from '../Tasks/Delete.vue'

export default { 
	components: {
		List,
		Add,
		Edit,
		Delete,
		Search
	},
	data() {
		return {
			selected: null,
			deleteOpen: false,
			editOpen: false,
			addOpen: false,
			foundTasks: []
		}
	},
	computed : {
		...mapState({
			tasks: state => state.tasks.list
		})
	},
	methods: {
		deleteTask(task) {
			this.selected = task
			this.deleteOpen = true
		},
		editTask(task) {
			this.selected = task
			this.editOpen = true
		},
		filteredList(items) {
			if(items.length > 0) {
				this.foundTasks = items;
			} 
		}
	},
	mounted() {
		this.$store.commit('app/setLoading', true)
		const tasks = this.$store.dispatch('tasks/getList')

		Promise.all([tasks])
		.then(() => {
			this.$store.commit('app/setLoading', false);
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false);
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Pages/Tasks.vue